import { getIsApiPending } from '../../../selectors/naMotorInsurance/travelAgentModal';
import { apiTransitionAgents, setAllAgentsValue } from '../../../actions/naMotorInsurance/motorAgentModal';
import { getAccessToken } from '../../../selectors/naMotorInsurance/payments';
import { getIntermediaryType } from '../../../selectors/naMotorInsurance/travelAgentModal';
import axios from 'axios';

export const getAgentsService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionAgents.pending());
            try {
                const resp = await getAgents(store.getState());
                store.dispatch(setAllAgentsValue(resp.data.agents));
                store.dispatch(apiTransitionAgents.success());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionAgents.failure());
            }
        }
    })();
    return next(action);
};

const getAgents = async (state) => {
    const loginData = getAccessToken(state);

    const intermediaryType = getIntermediaryType(state);

    const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;

    try {
        let url = '';

        switch (gatsbyStack) {
            case 'ke':
                url = '/om-api/ke-motor-insurance/agents';
                break;
            case 'na':
                url = '/om-api/na-motor-insurance/agents';
                break;
            default:
                url = '/om-api/ug-motor-insurance/agents';
                break;
        }

        return await axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                type: intermediaryType.value,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
